import type { InstitutionalInvestorsProps } from "@/types/components/investor/institutional-investors";
import { useRef, type FC } from "react";
import SplitTextAnimation from "../split-text-animation";
import { Image } from "../image";
import { useInView } from "@/hooks/reveal-in-view";

export const InstitutionalInvestors: FC<InstitutionalInvestorsProps> = ({title, logos}) => {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

	const bridgeport = logos[0];
	const moore = logos[1];
	const motivate = logos[2];
	const presidio = logos[3];
	const ps27 = logos[4];
	const pre = logos[5];
	const transcard = logos[6];

  return (
    <section className="institutionalInvestors">
		<div className="wrapper">
			<SplitTextAnimation
				htmlElement={
				<h2 className="institutionalInvestors--title" ref={ref}>
					{title}
				</h2>
				}
				isInView={isInView}
			/> 
			<div className="institutionalInvestors--logoContainer">
				<div className="institutionalInvestors--logoWrapper">
					<a href="https://www.bgptpartners.com/" target="_blank">
						<Image
							key={bridgeport.title}
							className={`institutionalInvestors--bridgePort`}
							src={bridgeport as any}
							alt={bridgeport.title}
							animateInView
						/>
					</a>
				</div>
				<div className="institutionalInvestors--logoWrapper">
					<a href="https://www.moorecap.com" target="_blank">
						<Image
							key={moore.title}
							className={`institutionalInvestors--moore`}
							src={moore as any}
							alt={moore.title}
							animateInView
						/>
					</a>
				</div>
				<div className="institutionalInvestors--logoWrapper">
					<a href="https://motivate.vc/" target="_blank">
						<Image
							key={motivate.title}
							className={`institutionalInvestors--motivate`}
							src={motivate as any}
							alt={motivate.title}
							animateInView
						/>
					</a>	
				</div>
				<div className="institutionalInvestors--logoWrapper">
					<a href="https://presidio-ventures.com/" target="_blank">
						<Image
							key={presidio.title}
							className={`institutionalInvestors--presidio`}
							src={presidio as any}
							alt={presidio.title}
							animateInView
						/>
					</a>
				</div>
				<div className="institutionalInvestors--logoWrapper">
					<a href="https://ps27ventures.com/" target="_blank">
						<Image
							key={ps27.title}
							className={`institutionalInvestors--ps27`}
							src={ps27 as any}
							alt={ps27.title}
							animateInView
						/>
					</a>
				</div>
				<div className="institutionalInvestors--logoWrapper">
					<a href="https://www.rre.com/" target="_blank">
						<Image
							key={pre.title}
							className={`institutionalInvestors--pre`}
							src={pre as any}
							alt={pre.title}
							animateInView
						/>
					</a>
				</div>
				<div className="institutionalInvestors--logoWrapper">
					<a href="https://www.transcard.com/" target="_blank">
						<Image
							key={transcard.title}
							className={`institutionalInvestors--transcard`}
							src={transcard as any}
							alt={transcard.title}
							animateInView
						/>
					</a>
				</div>
			</div>
		</div>
    </section>
  )
}